/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGraphSchema } from '../../entities/graph/GraphSchema';

export type TGetGraphDataModel = IModel<IGetGraphDataRequest, TGetGraphDataResponse>;

export interface IGetGraphDataRequest {
  /** Тип графика **/
  graphType?: EGraphType | null;
}

export type TGetGraphDataResponse = IGetGraphDataResponse200 | IGetGraphDataResponse400;

export interface IGetGraphDataResponse200 extends IModelResponse<IGetGraphDataResponse> {
  statusCode: 200;
}

export interface IGetGraphDataResponse400 extends IModelResponse<IGetGraphDataResponseError> {
  statusCode: 400;
}

export interface IGetGraphDataResponse {
  /** Список датасетов для графика **/
  graphs: IGraphSchema[];
  /** Список значений по оси x **/
  labels: string[];
}

export interface IGetGraphDataResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetGraphDataResponse | IGetGraphDataResponseError;

export enum EGraphType {
  /** Число сделок с физическими лицами на первичном рынке **/
  DealCountPrimary = 'dealCountPrimary',
  /** Доля ипотечных сделок на первичном рынке **/
  DealPercentPrimary = 'dealPercentPrimary',
  /** Средняя цена квадратного метра на вторичном рынке **/
  PriceSqmSecondary = 'priceSqmSecondary',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetGraphDataResponse): TResponse200;
  400(response: IGetGraphDataResponseError): TResponse400;
}
